import { Component, Input } from '@angular/core'
import { Marked, Renderer } from '@ts-stack/markdown'
import { TypographyColor, TypographyComponent } from '../typography'

@Component({
  standalone: true,
  selector: 'hyperkit-markdown',
  imports: [TypographyComponent],
  styleUrls: ['./markdown.component.scss'],
  templateUrl: './markdown.component.html',
})
export class MarkdownComponent {
  public html = ''
  @Input() public color: TypographyColor = 'secondary'

  @Input()
  public set md(value: string) {
    Marked.setOptions({
      renderer: new Renderer(),
      gfm: true,
      tables: false,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    })
    this.html = Marked.parse(value)
  }
}
